export const CONFIG = {
  BASE_DOMAIN: process.env.REACT_APP_BASE_DOMAIN || '',
  DEFAULT_REDIRECT_URL: process.env.REACT_APP_DEFAULT_REDIRECT_URL || '',
  API_SERVER: process.env.REACT_APP_API_SERVER || '',
  AUTH_SERVER: process.env.REACT_APP_AUTH_SERVER || '',
}
